// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1LQaM","gfeWrapper":"CalendarEvent_gfeWrapper__2x_EU"};